module.exports = __webpack_public_path__ + "3f16e137/img/upload-icon.9179ae4e.svg";